<template>
  <Container :indent="data.content_centered ? 'center' : 'wide'" class="pt-nav">
    <header>
      <Breadcrumbs class="mb-6 mt-4 md:mt-8 lg:mt-14" />
      <AnimatedContainer>
        <h1
          class="fade-in max-w-title text-3xl font-medium sm:text-5xl md:text-6xl"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <Bard
          v-if="data.text"
          :data="data.text"
          class="fade-in my-5 sm:text-lg"
        />
      </AnimatedContainer>
      <AppButton
        v-if="data.link"
        :target="data.target?.value"
        class="mt-4"
        :to="data.link"
      >
        {{ data.link_text }}
      </AppButton>
    </header>
  </Container>
</template>

<script setup>
defineProps({
  data: { type: Object, required: true },
})

const { setIsWhite } = useNavigationStore()

onMounted(() => {
  setIsWhite(true)
})
</script>

<style lang="scss">
.bard {
  a {
    @apply text-blue-800;
  }
}
</style>
